'use client';
import { BadgeStyled } from './badge.styles';

declare module '@mui/material/Badge' {
  interface BadgePropsColorOverrides {
    tertiary: true;
  }
}

const Badge = BadgeStyled;

export default Badge;
